<template>
    <div class="loan-calculator">
        <h1> {{ t('loan_calculator_header') }}</h1>
        <iframe 
            src="https://reiknivel.gildi.is/husnaedislan" 
            width="100%" 
            height="600" 
            frameborder="0"
            />
    </div>
</template>

<script setup lang="ts">
    import { useI18n } from 'vue-i18n'
    const { t } = useI18n()
    
</script>

<style scoped>
/* .loan-calculator {
    Add your styles here
} */
</style>